import { useEffect, useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { Form } from 'react-simple-form-control';
import solicitacaoService from '../../services/SolicitacaoService';
import cargoService from '../../services/CargoService';
import { isNullOrEmptyOrWhiteSpaceOrUndefined, aplicarMascaraTelefone } from '../../helpers/Helper';

const DadosAdministradorConveniada = ({ form, onChangeForm, setLoading, handleResponsavelChangeSet, ChangeMaskTelefoneAdmin }) => {
    const [checkCelularAdmin, setCheckCelularAdmin] = useState(form.tipoTelefoneComercialAdmin.value == '1');
    const [checkFixoAdmin, setCheckFixoAdmin] = useState(form.tipoTelefoneComercialAdmin.value == '2');

    useEffect(() => {
        load();
    }, []);

    async function load() {
        setLoading(true);
        let _form = { ...form };

        const listCargo = await cargoService.OnGetListaCodigoDescricao();

        _form.listCargo.value = listCargo;

        onChangeForm(_form);
        setLoading(false);
    }

    async function onClickTipoTelefoneAdmin(event) {
        setLoading(true);
        let _form = { ...form };
        const tipo = event.target.value;
        _form.tipoTelefoneComercialAdmin.value = tipo;
        // Atualiza a máscara do valor atual
        //_form.telefoneComercialAdmin.value = aplicarMascaraTelefone(_form.telefoneComercialAdmin.value, tipo);
        _form.telefoneComercialAdmin.mask = tipo === '1' ? "(99) 99999-9999" : "(99) 9999-9999";
        _form.telefoneComercialAdmin.value = '';

        setCheckCelularAdmin(tipo == '1');
        setCheckFixoAdmin(tipo == '2');
        setLoading(false);
        onChangeForm(_form);
    }

    async function handleCPFAdminChange(event) {
        setLoading(true);

        handleInputChange(event);

        let _form = { ...form };
        var cpfInformado = event.target.value.substr(0, 14);
        if (cpfInformado === "000.000.000-00"
            || cpfInformado == ''
            || cpfInformado == undefined
            || cpfInformado == null
            || cpfInformado == 0) {
            _form.cpfAdmin.value = "";
            _form.nomeAdmin.value = '';
            _form.emailAdmin.value = '';
            _form.telefoneAdmin.value = '';
            _form.telefoneComercialAdmin.value = '';
            _form.idTelefoneAdmin.value = 0;
            _form.idPessoaAdmin.value = 0;
            _form.habilitaDadosAdmin.value = false;
            onChangeForm(_form);
            setLoading(false);
        }
        if (cpfInformado !== undefined &&
            cpfInformado !== null &&
            cpfInformado !== "" &&
            cpfInformado !== 0 &&
            cpfInformado !== "000.000.000-00" &&
            cpfInformado.length === 14) {
            if (_form.cpfRepresentante.value == cpfInformado) {
                var cpf = cpfInformado;
                _form.cpfAdmin.value = '';
                _form.nomeAdmin.value = '';
                _form.emailAdmin.value = '';
                _form.telefoneAdmin.value = '';
                _form.telefoneComercialAdmin.value = '';
                _form.idTelefoneAdmin.value = 0;
                _form.idPessoaAdmin.value = 0;
                _form.cpfAdmin.ref.current.focus();
                _form.habilitaDadosAdmin.value = false;
                onChangeForm(_form);
                setLoading(false);
                toast.warn("O CPF informado [" + cpf + "] foi informado no campo do cpf do Representante.");
            }
            else {
                const res = await solicitacaoService.getDadosPorCPF(cpfInformado.replace('.', '').replace('.', '').replace('/', '').replace('-', ''));
                if (res.success === true && res.data !== null && res.data !== undefined) {
                    if (res.data.user !== null) {
                        _form.nomeAdmin.value = res.data.nome || res.data.user.nome || '';
                        _form.emailAdmin.value = res.data.email || res.data.user.email || '';
                        if (res.data.user.cdPhoneCelular != null) {
                            _form.telefoneAdmin.value = res.data.user.celular || '';
                            _form.idTelefoneAdmin.value = res.data.user.cdPhoneCelular || null;
                        } else {
                            _form.telefoneAdmin.value = '';
                            _form.idTelefoneAdmin.value = 0;
                        }
                        if (res.data.user.cdPhoneComercial != null) {
                            if (res.data.user.comercial.length == 10)
                                setCheckFixoAdmin(true);
                            else
                                setCheckCelularAdmin(true);

                            _form.tipoTelefoneComercialAdmin.value = res.data.user.comercial.length == 10 ? 2 : 1;
                            _form.telefoneComercialAdmin.value = res.data.user.comercial || '';
                            _form.idTelefoneComercialAdmin.value = res.data.user.cdPhoneComercial || null;
                        }
                        else {
                            _form.tipoTelefoneComercialAdmin.value = 0;
                            _form.telefoneComercialAdmin.value = '';
                        }
                        _form.ruPessoaAdmin.value = res.data.user.ru || 0;
                        _form.habilitaDadosAdmin.value = (res.data.nome != '' && res.data.nome != null && res.data.user.nome != '' && res.data.user.nome != null);
                    }
                    if (res.data.id > 0) {
                        _form.nomeAdmin.value = res.data.nome || '';
                        _form.emailAdmin.value = res.data.user !== null ? res.data.user.email || res.data.email : res.data.email || '';
                        if (res.data.cdPhoneCelular != null) {
                            _form.telefoneAdmin.value = res.data.celula || '';
                            _form.idTelefoneAdmin.value = res.data.cdPhoneCelular || null;
                        } else {
                            _form.telefoneAdmin.value = res.data.user !== null ? res.data.user.celular || 0 : 0;
                            _form.idTelefoneAdmin.value = res.data.user !== null ? res.data.user.cdPhoneCelular || 0 : 0;
                        }
                        if (res.data.cdPhoneComercial != null) {
                            if (res.data.comercial.length == 10)
                                setCheckFixoAdmin(true);
                            else
                                setCheckCelularAdmin(true);

                            _form.tipoTelefoneComercialAdmin.value = res.data.comercial.length == 10 ? 2 : 1;
                            _form.telefoneComercialAdmin.value = res.data.comercial || '';
                            _form.idTelefoneComercialAdmin.value = res.data.cdPhoneComercial || null;
                        }
                        else {
                            _form.tipoTelefoneComercialAdmin.value = res.data.user !== null && res.data.user.comercial != null ? res.data.user.comercial.length == 10 ? 2 : 1 : 0;
                            _form.telefoneComercialAdmin.value = res.data.user !== null ? res.data.user.comercial || '' : '';
                            _form.idTelefoneComercialAdmin.value = res.data.user !== null ? res.data.user.cdPhoneComercial || null : null;
                        }

                        _form.idPessoaDCAdmin.value = res.data.idPessoaDadosCadastrais || 0;
                        _form.idPessoaAdmin.value = res.data.id || 0;
                        _form.habilitaDadosAdmin.value = (res.data.nome != '' && res.data.nome != null);
                    }
                }
                else {
                    _form.nomeAdmin.value = '';
                    _form.emailAdmin.value = '';
                    _form.telefoneAdmin.value = '';
                    _form.telefoneComercialAdmin.value = '';
                    _form.idTelefoneAdmin.value = 0;
                    _form.idPessoaAdmin.value = 0;
                    _form.idPessoaDCAdmin.value = 0;
                    _form.ruPessoaAdmin.value = 0;
                    _form.habilitaDadosAdmin.value = false;
                }
            }
            onChangeForm(_form);
            setLoading(false);
        } else {
            setLoading(false);
        }
    }

    async function handleCargoAdminChange(event) {
        let _form = { ...form };
        _form.cargoAdmin.value = event.value;
        onChangeForm(_form);
    }

    async function handleAdminIsRepresentante(event) {
        handleInputChange(event);

        let _form = { ...form };

        if (_form.adminRepresentante.value)
            handleResponsavelChangeSet(_form.nomeAdmin.value.trim(), 'nomeAdmin');
        else {
            const indexItem = _form.listResponsaveis.value.map((e) => e.codigo).indexOf('nomeAdmin');

            if (indexItem > -1)
                _form.listResponsaveis.value.splice(indexItem, 1);
        }

        onChangeForm(_form);
    }

    async function handleInputChange(e) {
        const { name, value, type, checked } = e.target;
        let _form = { ...form };
        let novoValor = type === "checkbox" ? checked : value;

        if (name === "telefoneComercialAdmin") {
            const tipo = _form.tipoTelefoneComercialAdmin.value;
            novoValor = aplicarMascaraTelefone(novoValor, tipo);
        }
        _form[name].value = novoValor;
        onChangeForm(_form);
    }

    return (
        <Form formControl={form}>
            <div className="card-body">
                <ul className="uninterconvenioempresas uninter-passo-interno">
                    <li>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                            <label>CPF</label>
                            <input type="text" id="cpfAdmin" name="cpfAdmin" onBlur={handleCPFAdminChange} />
                            <span className="error" id="cpfAdminError"></span>
                        </div>

                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                            <label>Nome</label>
                            <input type="text" id="nomeAdmin" name="nomeAdmin" disabled={form.habilitaDadosAdmin.value}
                                value={form.nomeAdmin.value} onChange={handleInputChange} />
                            <span className="error" id="nomeAdminError"></span>
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                            <label>RG</label>
                            <input type="text" id="rgAdmin" name="rgAdmin"
                                value={form.rgAdmin.value} onChange={handleInputChange} />
                            <span className="error" id="rgAdminError"></span>
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                            <label htmlFor="ddlCargoAdmin">Cargo</label>
                            <Select
                                onChange={handleCargoAdminChange}
                                isLoading={form.listCargo.value.length > 0 ? false : true}
                                options={form.listCargo.value.map((o, i) => {
                                    return { id: i, value: o.codigo, label: o.descricao };
                                })}
                                placeholder="SELECIONE"
                                id={"cargoAdmin"}
                                name={"cargoAdmin"}
                                defaultValue={{ label: "SELECIONE", value: 0 }}
                                value={
                                    form.cargoAdmin.value !== null
                                        ? form.listCargo.value.find(e => e.codigo === form.cargoAdmin.value) && {
                                            label: form.listCargo.value.find(e => e.codigo === form.cargoAdmin.value)?.descricao,
                                            value: form.cargoAdmin.value
                                        }
                                        : { label: "SELECIONE", value: 0 }
                                }
                            />
                            <span className="error" id="cargoAdminError"></span>
                        </div>

                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 uninter-campos">
                            <label>Email</label>
                            <input type="email" id="emailAdmin" name="emailAdmin" maxLength="250"
                                value={form.emailAdmin.value} onChange={handleInputChange} />
                            <span className="error" id="emailAdminError"></span>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 uninter-campos">
                            <label>Telefone Celular</label>
                            <input type="text" id="telefoneAdmin" name="telefoneAdmin"
                                onBlur={(e) => handleInputChange(e)} />
                            <span className="error" id="telefoneAdminError"></span>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 uninter-campos">
                            <ul className="uninter-declaro-convenioempresas">
                                <label className="label">Tipo Telefone Comercial</label>
                                <li className="form-check">
                                    <input type="radio" id="CelularAdmin" name="tipoTelefoneComercialAdmin" checked={checkCelularAdmin} onClick={onClickTipoTelefoneAdmin} value="1" />
                                    <label className="label">Celular</label>
                                    <input type="radio" id="FixoAdmin" name="tipoTelefoneComercialAdmin" checked={checkFixoAdmin} onClick={onClickTipoTelefoneAdmin} value="2" />
                                    <label className="label">Fixo</label>
                                </li>
                            </ul>
                            <center><span className="error" id="tipoTelefoneComercialAdminError"></span></center>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 uninter-campos">
                            <label>Telefone Comercial</label>
                            <input type="text" id="telefoneComercialAdmin" name="telefoneComercialAdmin" disabled={form.tipoTelefoneComercialAdmin.value == 0}
                                value={form.telefoneComercialAdmin.value}
                                onChange={handleInputChange} />
                            <span className="error" id="telefoneComercialAdminError"></span>
                        </div>
                        <br />
                        <div className="col-xs-6 col-sm-4 col-md-4 col-lg-4 uninter-campos">
                            <ul className="uninter-declaro-convenioempresas">
                                <label className="label" tooltip-position="bottom" tooltip="Selecionar quando o administrador também for o representante legal da conveniada.">Representante legal</label>
                                <li className="form-check">
                                    <input type="checkbox" id="adminRepresentante" name="adminRepresentante" value="1" disabled={isNullOrEmptyOrWhiteSpaceOrUndefined(form.cpfAdmin.value) || isNullOrEmptyOrWhiteSpaceOrUndefined(form.nomeAdmin.value)} onBlur={handleAdminIsRepresentante} />
                                    <label className="label">Sim</label>
                                </li>
                            </ul>
                        </div>
                        <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 uninter-campos" hidden={form.tipoConvenio.value == 1 || form.tipoConvenio.value == 0}>
                            <ul className="uninter-declaro-convenioempresas">
                                <label className="label" tooltip-position="bottom" tooltip="Selecionar quando for necessário envio de nota por e-mail.">Receber nota por e-mail</label>
                                <li className="form-check">
                                    <input type="checkbox" id="recebeEmailNotaAdm" name="recebeEmailNotaAdm" value="1" checked={form.recebeEmailNotaAdm.value} onChange={handleInputChange} />
                                    <label className="label">Sim</label>
                                </li>
                            </ul>
                        </div>
                        <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 uninter-campos uninter-campos" hidden={form.tipoConvenio.value == 1 || form.tipoConvenio.value == 0}>
                            <ul className="uninter-declaro-convenioempresas">
                                <label className="label" tooltip-position="bottom" tooltip="Selecionar quando for necessário envio de boleto por e-mail.">Receber boleto por e-mail</label>
                                <li className="form-check">
                                    <input type="checkbox" id="recebeEmailBoletoAdm" name="recebeEmailBoletoAdm" value="1" checked={form.recebeEmailBoletoAdm.value} onChange={handleInputChange} />
                                    <label className="label">Sim</label>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </Form>
    );
}

export default DadosAdministradorConveniada;